
export default [{
  path: '/dashboard/:ctype',
  name: 'Scorecard',
  component: resolve => require(['@/view/ReportCenter/readiness/index.vue'], resolve)
},
{
  path: '/rules/config',
  name: 'Rules Config',
  component: resolve => require(['@/view/ReportCenter/rules_config/index.vue'], resolve)
},
{
  path: '/readiness/monitor',
  name: 'Readiness Monitor',
  component: resolve => require(['@/view/ReportCenter/readiness_monitor/index.vue'], resolve)
},
{
  path: '/smile/bizcatelog',
  name: 'Business Catelog',
  component: resolve => require(['@/view/ReportCenter/bizcatelog/index.vue'], resolve)
},
]



// WEBPACK FOOTER //
// ./src/router/dashboard.js